import { SiteCoreDictionary } from '@eika-kortbetjening/types';

const fallbackDictionary: SiteCoreDictionary = {
    digitalCardTitle: 'Se digitalt kort',
    pinViewText: 'Se PIN-kode',
    blockSoftOpen: 'Åpne kortet',

    cardLabelSoftBlocked: 'Kortet er midlertidig sperret',
    cardLabelSystemSoftBlocked: 'Kortet er sperret - ta kontakt med banken',
    cardLabelBlocked: 'Kortet er sperret',
    cardLabelOrdered: 'Kortet er bestilt',
    cardLabelExpired: 'Kortet er utløpt',
};

export default fallbackDictionary;
